import { animate, query, stagger, style, transition, trigger } from '@angular/animations';
import { Component, OnInit, Input, ChangeDetectionStrategy, Output, EventEmitter, ContentChild, TemplateRef, ChangeDetectorRef, ViewChild, NgZone, OnChanges, SimpleChanges } from '@angular/core';
import { MatSelectionList, MatSelectionListChange } from '@angular/material/list';
import { VirtualScrollerComponent } from '@iharbeck/ngx-virtual-scroller';
import { filterItems } from '@internal/common-ui/common';
import * as _ from 'lodash';
import { ObjectUtils } from 'primeng/utils';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
  selector: 'local-navigation',
  templateUrl: './local-navigation.component.html',
  styleUrls: ['./local-navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('listAnimation', [
      transition('* => *', [ // each time the binding value changes
        // query('.visible:leave', [
        //   stagger(10, [
        //     animate('0.05s', style({ opacity: 0 }))
        //   ])
        // ], { optional: true }),
        query('.visible:enter', [
          style({ opacity: 0 }),
          stagger(3, [
            animate('0.1s ease-in', style({ opacity: 1 }))
          ])
        ], { optional: true }),
        query('.mat-list-item:enter', [
          style({ opacity: 0 }),
          stagger(10, [
            animate('0.1s ease-in', style({ opacity: 1 }))
          ])
        ], { optional: true })
      ])
    ])
  ]
})
export class LocalNavigationComponent implements OnInit, OnChanges {
  _items: any[] = [];
  @Input()
  get items() {
    return this._items;
  }
  set items(val) {
    // shouldn't allow null
    // this._items = (val || []).map(item => {
    //   return {
    //     ...item,
    //     // selected: false,
    //     expanded: false
    //   }
    // });
    this._items = val || [];
    this.filteredItems = filterItems(this._items, this.searchKeys, this._filter && this._filter.toLowerCase(), 'contains');
    // this.onItemFiltered.next(this.filteredItems);
    // !no selected property on items any more
    if (this.scroll) {
      // const selectItem = this.filteredItems.find(p => p['selected']);
      if (this.selectedItem && this.scroll.viewPortItems?.find(p => p === this.selectedItem)) {
        const index = this.filteredItems.indexOf(this.selectedItem);
        if (index >= 0) {
          this.scroll.scrollToIndex(index);
        }
      }
    }
  }

  @Input()
  selectedItem: any;

  @Input()
  multiple = false;

  @Input()
  maxSelectionLength = 1000;

  @Input()
  itemSize = 68;

  @Input()
  scrollHeight = this.itemSize * 10 + 'px';

  @Input()
  minBufferPx = this.itemSize * 10;

  @Input()
  maxBufferPx = this.itemSize * 40;

  @Input()
  nameField: string = '';

  @Input()
  dataKey: string = '';

  @Input()
  checkboxPosition: string = 'before';

  @Input()
  showCheckAll = false;

  @Input()
  headerClass = '';

  @Input()
  showTitle = false;

  @Input()
  title = '';

  @Input()
  showSearch = false;

  @Input()
  searchLabel = '';

  @Input()
  searchKeys = [];

  @Input()
  navClass = 'a-loc-nav';

  @Input()
  itemClass = '';

  @Input()
  scrollerClass = 'thin-scroller';

  @Input()
  virtualScroll = true;

  @Input()
  performance = false;

  @Input()
  searchPlaceholder = 'Search here...';

  @Input()
  scrollToSelected = false;

  @Input()
  selectable = true;

  @Input()
  disabled = false;

  // use to support click on selected item again
  // if user want to refresh the item
  // @Input()
  // clickable = false;
  @Input()
  searchKey = '';
  @Output()
  searchKeyChange = new EventEmitter<string>();

  @Output()
  selectionChange = new EventEmitter<any | any[]>();

  //emit when filter by local-navi
  @Output()
  onItemFiltered = new EventEmitter<any[]>();

  // @Output()
  // onClick = new EventEmitter<any>();

  // the item template
  @ContentChild(TemplateRef, { static: false })
  itemTemplate: TemplateRef<any>;

  @ViewChild('list', { static: false })
  private list: MatSelectionList;

  @ViewChild('scroll', { static: false })
  private scroll: VirtualScrollerComponent;

  filteredItems: any[];

  private _filter = '';
  get filter() {
    return this._filter;
  }
  set filter(val) {
    this._filter = val;
    this.filteredItems = filterItems(this._items, this.searchKeys, val && val.toLowerCase(), 'contains');
    this.onItemFiltered.next(this.filteredItems);
  }

  get checkedAll() {
    return this.selectedItem && this.filteredItems &&
      this.filteredItems.length && this.filteredItems.length == this.selectedItem.length;
  }

  constructor(private cd: ChangeDetectorRef,
    private ngZone: NgZone) { }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log(changes);
  }

  ngOnInit() {
    if (this.list) {
      if (this.list['_onFocus']) {
        // know issue in v9 (fixed in v10): https://github.com/angular/components/issues/18651#issuecomment-706505316
        this.list['_onFocus'] = () => { };
      }
      // disabled but clickable
    }
    this.filteredItems = filterItems(this._items, this.searchKeys, this._filter && this._filter.toLowerCase(), 'contains');
    this.onItemFiltered.next(this.filteredItems);
  }
  onSearch(event) {
    this.filter = event;
  }


  itemFiltered(items) {
    this.filteredItems = items;
    const selectedItem = this.filteredItems.find(p => p['selected']);
    if (selectedItem && !this.selectedItem) {
      this.selectedItem = selectedItem;
    }
    if (this.filteredItems && !this.filteredItems.find(item => item == this.selectedItem)) {
      this.selectedIndex = -1;
      this.selectedItem = null;
      this.selectionChange.next(this.selectedItem);
    }
    this.checkFirstLast();
  }

  deselectAll() {
    if (this.list) {
      this.list.deselectAll();
    }
    // this.filteredItems.forEach(item => item.selected = false);
    this.cd.detectChanges();
  }
  selectedIndex;
  // selectedItem;
  isFirst;
  isLast;

  // select(offSet) {
  //   const filteredItems = this.filteredItems.filter(item => !this.performance || item.filtered == false);
  //   // const selectedIndex = filteredItems.findIndex(item => item.selected);
  //   // const nextIndex = selectedIndex + offSet;

  //   if (nextIndex < filteredItems.length && nextIndex > -1) {
  //     // filteredItems[selectedIndex].selected = false;
  //     // filteredItems[selectedIndex + offSet].selected = true;
  //     this.selectedItem = filteredItems[selectedIndex + offSet];
  //     this.selectedIndex = nextIndex;

  //   } else {
  //     console.warn('last one');
  //   }
  //   this.checkFirstLast();
  //   this.selectionChange.next(this.selectedItem);
  //   if (this.scroll && this.scrollToSelected && this.scroll.viewPortItems.findIndex(p => p == this.selectedItem) == -1) {
  //     if (offSet > 0) {
  //       this.scroll.scrollToIndex(this.selectedIndex);
  //     }
  //     else {
  //       this.scroll.scrollToIndex(this.selectedIndex - this.scroll.viewPortItems.length);
  //     }
  //     // console.log(this.scroll.viewPortItems);
  //   }
  //   this.cd.detectChanges();
  // }

  isSelected(option: any) {
    let selected = false;

    if (this.selectedItem instanceof Array && this.selectedItem != null) {
      for (let val of this.selectedItem) {
        if (ObjectUtils.equals(val, option, this.dataKey)) {
          selected = true;
          break;
        }
      }
    }
    else {
      selected = ObjectUtils.equals(this.selectedItem, option, this.dataKey);
    }

    return selected;
  }

  // On virtual scroller mode, event only contains items selected in rendered items
  // Other items selected but not rendered will be ignored
  // Need consider more on virtual scroller
  onSelectionChange(event: MatSelectionListChange) {
    if (!this.multiple) {
      const selectItem = event.options;
      // this.ngZone.runOutsideAngular(() => {
      //   this._items.forEach((item, index) => {
      //     if (item == selectItem) {
      //       this.selectedItem = item;
      //     }
      //     else {
      //   this.checkFirstLast();
      // });
      this.checkFirstLast();
      this.cd.detectChanges();
      this.selectedItem = selectItem;
      this.selectionChange.next(selectItem);
    }
    else {
      const visibleItems = event.source.options.map(item => item.value);
      const visibleSelectedItems = event.source.selectedOptions.selected.map(p => p.value);
      const selectedItemsOutsideView = _.differenceWith(this.selectedItem, visibleItems,
        (x, y) => ObjectUtils.equals(x, y, this.dataKey)
      )
      const selectedItems = [...selectedItemsOutsideView, ...visibleSelectedItems];
      this.selectedItem = selectedItems;
      this.selectionChange.next(selectedItems);
    }
  }

  checkAllChanged(event: MatCheckboxChange) {
    if (this.list) {
      if (event.checked) {
        this.selectionChange.next(this.filteredItems);
        // this.list.selectAll();
      }
      else {
        this.selectionChange.next([]);
      }
      // const visibleItems = this.list.options.map(item => item.value);
      // const visibleSelectedItems = this.list.selectedOptions.selected.map(p => p.value);
      // const selectedItemsOutsideView = _.differenceWith(this.selectedItem, visibleItems,
      //   (x, y) => ObjectUtils.equals(x, y, this.dataKey)
      // )
      // const selectedItems = [...selectedItemsOutsideView, ...visibleSelectedItems];
      // this.selectionChange.next(selectedItems);
    }
  }


  itemClick(selectItem) {
    const selected = selectItem.selected;
    const filteredItems = this.filteredItems.filter(item => !this.performance || item.filtered != true);
    this.ngZone.runOutsideAngular(() => {
      filteredItems.forEach((item, index) => {
        if (item == selectItem) {
          // item.selected = true;
          this.selectedIndex = index;
          this.selectedItem = item;
        }
        else {
          // item.selected = false;
          // if (item.expanded) {
          //   item.expanded = false;
          // }
        }
      });
    });
    if (!selected)
      this.selectionChange.next(selectItem);
    // selectItem.selected = true;
    this.checkFirstLast();
  }

  private checkFirstLast() {
    const filteredItems = this.filteredItems.filter(item => !this.performance || item.filtered == false);
    this.selectedIndex = filteredItems.findIndex(item => item == this.selectedItem);
    this.isFirst = this.selectedIndex == 0;
    this.isLast = this.selectedIndex == filteredItems.length - 1;
  }

}
